var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"5","fill":"#FED501","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.6379 7.0309C10.4196 7.0309 7 10.4505 7 14.6688C7 18.8872 10.4196 22.3068 14.6379 22.3068C18.8563 22.3068 22.2759 18.8872 22.2759 14.6688C22.2759 10.4505 18.8563 7.0309 14.6379 7.0309ZM24.6852 24.6407C24.2602 25.0732 23.5611 25.0793 23.1286 24.6543L20.0755 21.6543C20.6563 21.2015 21.1791 20.6779 21.6311 20.0964L24.6716 23.0841C25.1041 23.5091 25.1102 24.2082 24.6852 24.6407ZM14.6379 9.1575C17.6818 9.1575 20.1492 11.625 20.1492 14.6688C20.1492 17.7126 17.6817 20.1801 14.6379 20.1801C11.5941 20.1801 9.12664 17.7126 9.12664 14.6688C9.12664 11.625 11.5941 9.1575 14.6379 9.1575Z","fill":"white","key":1})]);
}

Search.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Search;

Search.default = Search;
